import guid from "../utils/guid";
import helpers from "./helpers";
import { isEmptyStr, applyUniqueIDs } from "../utils/helpers.js";

console.log(helpers);

export default {
  setAnimationMode(state) {
    state.animationMode = !state.animationMode;
  },
  setPlayer(state, player) {
    state.player = player;
  },
  setPlayerTime(state, time) {
    if (state.player) {
      state.player.currentTime(time);
    }
  },
  selectTag(state, { tag, atRelativeTimePos }) {
    // Object.assign won't update nested object reference
    // Object.assign(state.selection, { tag })
    // update selection only if tag is not the selected
    if (tag !== state.selection.tag) {
      state.selection = { tag };
    }
    if (atRelativeTimePos) {
      state.player.currentTime(state.player.duration() * atRelativeTimePos);
    }
  },
  selectScene(state, scene) {
    if (!scene) {
      state.selection.scene = null;
      state.selection.waypoint = null;
      // state.selection.tag = null
      return;
    }
    const tags = state.video.tags;
    const tag = tags.find(t => t.scenes.indexOf(scene) >= 0);
    const waypoint = scene.waypoints[0];
    // Object.assign won't update nested object reference
    // Object.assign(state.selection, { tag, scene })
    state.selection = { tag, scene };
    // if scene is selected, do not select the waypoint unless the scene is new
    state.selection.waypoint = scene.waypoints.length === 1 ? waypoint : null;
    state.player.currentTime(waypoint.time);
    state.player.pause();
    state.mode = "editing";
  },
  selectWaypoint(state, waypoint) {
    const { tag, scene } = state.video.tags.reduce(
      (result, tag) =>
        result ||
        tag.scenes
          .filter(scene => scene.waypoints.indexOf(waypoint) >= 0)
          .map(scene => ({ tag, scene }))[0],
      null
    );
    state.selection = { tag, scene, waypoint };
    helpers.sortWaypoints(state.selection.scene.waypoints);
    state.player.currentTime(waypoint.time);
    state.player.pause();
    state.mode = "editing";
  },
  addScene(state, scene) {
    scene.id = guid();
    const tag = state.selection.tag;
    // tag.scenes.push(scene)
    state.selection.tag.scenes = [...state.selection.tag.scenes, scene];
    // state.selection = { tag, scene }
    state.selection = { ...state.selection, tag, scene };
    return scene;
  },
  deleteScene(state, scene) {
    const sidx = state.selection.tag.scenes.indexOf(scene);
    state.selection.tag.scenes.splice(sidx, 1);
    state.selection.scene = null;
  },
  addTag(state, tag) {
    tag.id = guid();
    tag.version = 0;
    // state.video.tags.unshift(tag)
    state.video.tags = [tag, ...state.video.tags];
    // state.selection = { tag }
    // state.selection = { ...state.selection, tag }
    state.selection.tag = tag;
    state.selection.scene = null;
    state.selection.waypoint = null;
    return tag;
  },
  updateMetadata(state, meta) {
    const tag = state.selection.tag;
    tag.version = tag.version + 1;
    state.selection.tag.meta = {
      ...state.selection.tag.meta,
      name: meta.name,
      initalShow: meta.initalShow,
      showTag: meta.initalShow,
      alignement: meta.alignement,
      vAlignement: meta.vAlignement,
      textAlignement: meta.textAlignement,
      buttonStyle: meta.buttonStyle,
      fontBaseSize: meta.fontBaseSize,
      fontWeight: meta.fontWeight,
      boxShadow: meta.boxShadow,
      borderRadius: meta.borderRadius,
      filter: meta.filter,
      imageSrc: meta.imageSrc,
      text: !isEmptyStr(meta.text) ? meta.text : null,
      title: meta.title ? meta.title : tag.meta.title ? tag.meta.title : "",
      linkLabel: meta.linkLabel ? meta.linkLabel : "",
      URL: meta.URL ? meta.URL : tag.meta.URL ? tag.meta.URL : "",
      stock: meta.stock ? meta.stock : "",
      eyecatcher: meta.eyecatcher ? meta.eyecatcher : "",
      icon: meta.icon ? meta.icon : "",
      shape: meta.shape ? meta.shape : {},
      top: meta.top ? meta.top : "",
      left: meta.left ? meta.left : "",
      bottom: meta.bottom ? meta.bottom : "",
      right: meta.right ? meta.right : "",
      width: meta.width ? meta.width : "100%",
      height: meta.height ? meta.height : "100%",
      loop: meta.loop ? meta.loop : false,
      behaviour: meta.behaviour ? meta.behaviour : {},
      onLastFrame: meta.onLastFrame ? meta.onLastFrame : {},
      animation: meta.animation ? meta.animation : {},
      value: meta.value ? meta.value : "",
      colorScheme: meta.colorScheme ? meta.colorScheme : {},
      scaleBehaviour: meta.scaleBehaviour ? meta.scaleBehaviour : {}
    };
    /* this is not reactive, see https://vuex.vuejs.org/guide/mutations.html#mutations-follow-vues-reactivity-rules and
    https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
    const tag = state.selection.tag
    tag.meta.initalShow = meta.initalShow
    tag.meta.alignement = meta.alignement
    tag.meta.textAlignement = meta.textAlignement
    tag.meta.filter = meta.filter
    tag.meta.imageSrc = meta.imageSrc
    tag.meta.text = !isEmptyStr(meta.text) ? meta.text : null
    tag.meta.title = meta.title ? meta.title : tag.meta.title ? tag.meta.title : ''
    tag.meta.linkLabel = meta.linkLabel ? meta.linkLabel : ''
    tag.meta.URL = meta.URL ? meta.URL : tag.meta.URL ? tag.meta.URL : ''
    tag.meta.stock = meta.stock ? meta.stock : ''
    tag.meta.eyecatcher = meta.eyecatcher ? meta.eyecatcher : ''
    tag.meta.icon = meta.icon ? meta.icon : ''
    tag.meta.shape = meta.shape ? meta.shape : {}
    tag.meta.top = meta.top ? meta.top : ''
    tag.meta.left = meta.left ? meta.left : ''
    tag.meta.bottom = meta.bottom ? meta.bottom : ''
    tag.meta.right = meta.right ? meta.right : ''
    tag.meta.width = meta.width ? meta.width : '100%'
    tag.meta.height = meta.height ? meta.height : '100%'
    tag.meta.loop = meta.loop ? meta.loop : false
    tag.meta.behaviour = meta.behaviour ? meta.behaviour : {}
    tag.meta.onLastFrame = meta.onLastFrame ? meta.onLastFrame : {}
    tag.meta.animation = meta.animation ? meta.animation : {}
    tag.meta.value = meta.value ? meta.value : ''
    tag.meta.colorScheme = meta.colorScheme ? meta.colorScheme : {} */
  },
  setTemplate(state, template) {
    const tag = state.selection.tag;
    tag.template = template;
  },
  deleteTag(state, tagToDelete) {
    state.video.tags = state.video.tags.filter(tag => tag !== tagToDelete);
    state.selection = {};
  },
  copyTag(state, tagToCopy) {
    const tag = JSON.parse(JSON.stringify(tagToCopy));
    applyUniqueIDs(tag);
    // tag.id = guid()
    state.video.tags.unshift(tag);
    state.selection = { tag };
  },
  deleteWaypoint(state, waypoint) {
    if (state.selection.waypoint === waypoint) {
      state.selection.waypoint = null;
    }
    // find the scene this waypoint belongs to
    const scene = state.video.tags.reduce(
      (scene, tag) =>
        scene || tag.scenes.find(s => s.waypoints.indexOf(waypoint) >= 0),
      null
    );
    if (scene) {
      // if it is not the last waypoint in the scene, just remove it
      if (scene.waypoints.length > 1) {
        const idx = scene.waypoints.indexOf(waypoint);
        scene.waypoints.splice(idx, 1);
      } else {
        // otherwise remove the waypoint
        scene.waypoints.splice(0, 1);
        // find the associated tag
        const tag = state.video.tags.find(
          tag => tag.scenes.indexOf(scene) >= 0
        );
        // remove the scene from the tag
        tag.scenes = tag.scenes.filter(s => s !== scene);
        // set the selected scene to null
        state.selection.scene = null;
      }
    }
  },
  commitWaypoint(state, waypoint) {
    // all state exepct time is already synced, behaviour for now is to continue playing and kick off tracker if desired
    waypoint.time = state.player.currentTime();
    state.selection.waypoint = null;
    helpers.sortWaypoints(state.selection.scene.waypoints);
  },
  copyWaypoint(state, wp) {
    const wps = state.selection.scene.waypoints;
    helpers.sortWaypoints(wps);
    let idx = wps.indexOf(wp);
    const nwp = wps[idx + 1];
    const dx2 = nwp ? (nwp.time - wp.time) / 2 : 1;
    const videoDuration = state.player.duration ? state.player.duration() : 0;
    const newWpTime =
      wp.time + dx2 < videoDuration ? wp.time + dx2 : videoDuration;
    const cwp = {
      id: guid(),
      time: newWpTime,
      w: wp.w,
      h: wp.h,
      x: wp.x,
      y: wp.y,
      pw: wp.pw,
      ph: wp.ph
    };
    state.selection.scene.waypoints.push(cwp);
    // FIX:: Copy Inital Waypoint
    // was: no set currentTime
    state.player.currentTime(cwp.time);
    state.selection.waypoint = cwp;
  },
  resetSelection(state) {
    state.selection = {};
  },
  notify(state, message) {
    message.id = guid();
    state.notifications.push(message);
  },
  setInfoKey(state, key) {
    state.info.key = key;
  },
  clearNotification(state, message) {
    var index = state.notifications.findIndex(x => x.id === message.id);
    state.notifications.splice(index, 1);
  },
  setMode(state, mode) {
    console.log("setMode", mode);
    state.mode = mode;
  },
  updateKeyFrame(state, newSelectedWaypoint) {
    const newSelectedWaypoints = state.keyFrame.selectedWaypoints.filter(wp => {
      return wp.wp !== newSelectedWaypoint.wp;
    });

    if (
      newSelectedWaypoints.length === state.keyFrame.selectedWaypoints.length
    ) {
      state.keyFrame.selectedWaypoints = [
        ...state.keyFrame.selectedWaypoints,
        newSelectedWaypoint
      ];
    } else {
      state.keyFrame.selectedWaypoints = [...newSelectedWaypoints];
    }
  },
  clearKeyFrame(state) {
    state.keyFrame.selectedWaypoints = [];
  },
  addTrackedWaypoints(state, data) {
    console.log("addTrackedWaypoints", data);
    if (data.type === "Once" && data.matches && data.matches.length > 0) {
      data.matches.forEach(m => {
        console.log("store once match", m.time, m.center.X, m.center.Y);
        state.selection.scene.waypoints.push({
          time: m.time,
          x: m.center.X,
          y: m.center.Y
        });
      });
    } else if (data.type === "Continuous" && data.match) {
      const m = data.match;
      console.log("store continous match", m.time, m.center.X, m.center.Y);
      const existing = helpers.findWaypointWithinTimeInterval(m.time, 3 / 24);
      if (existing) {
        console.log(
          "skip tracker waypoint %v since it overlaps tolerance %v",
          m,
          existing
        );
        return;
      }
      const wp = helpers.createWaypointFromTrackpoint(m);
      state.selection.scene.waypoints.push(wp);
      state.player.currentTime(wp.time);
    }
  },
  // removes all tracked waypoints from the selected scene
  removeTrackedWaypoints(state, data) {
    if (!state.selection.scene) {
      throw new Error("removeTrackedWaypoints: no scene selected");
    }
    state.selection.scene.waypoints = (state.selection.scene
      ? state.selection.scene.waypoints
      : []
    ).filter(wp => {
      return wp.type !== "tracked";
    });
  },
  // promotes all waypoints in a scene to manual
  promoteTrackedWaypoints(state, data) {
    if (!state.selection.scene) {
      throw new Error("promoteTrackedWaypoints: no scene selected");
    }
    (state.selection.scene ? state.selection.scene.waypoints : []).forEach(
      wp => {
        wp.type = "manual";
      }
    );
  },
  updateQuiz(state, data) {
    const tag = state.selection.tag;
    tag.version = tag.version + 1;
    tag.meta.name = data.name || "";
    // explicit mapping {{ ..data.quiz }} destroys reactivity
    tag.meta.quiz = data.quiz;
    tag.meta.quiz.answers = data.quiz.answers;
  },
  updateQuizzes(state, data) {
    const tag = state.selection.tag;
    tag.version = tag.version + 1;
    for (let i = 0; i < tag.meta.quizzes.length; i++) {
      if (tag.meta.quizzes[i].id === data.quiz.id) {
        tag.meta.quizzes[i] = data.quiz;
      }
    }
    tag.meta.quiz = data.quiz;
  },
  saveQuizzes(state, data) {
    const tag = state.selection.tag;
    tag.meta.quizzes = data;
  },
  addQuizToQuizzes(state, data) {
    const tag = state.selection.tag;
    tag.version = tag.version + 1;
    tag.meta.quizzes.push(data.quiz);
    tag.meta.quiz = data.quiz;
  },
  setQuiz(state, data) {
    const tag = state.selection.tag;
    tag.meta.quiz = { ...data };
  },
  removeQuizFromQuizzes(state, data) {
    const tag = state.selection.tag;
    tag.meta.quizzes = tag.meta.quizzes.filter(quiz => {
      return quiz.id !== data;
    });
  },
  updateSingleChoice(state, data) {
    const tag = state.selection.tag;
    tag.meta.name = data.name || "";
    tag.meta.singleChoice = { ...data.singleChoice };
  },
  updateEmbed(state, data) {
    console.log("updateEmbed");
    const tag = state.selection.tag;
    tag.meta.title = data.title || "";
    tag.meta.URL = data.URL || null;
    tag.meta.initalShow = true;
    tag.meta.defKey = data.defKey;
    tag.payload = data.payload;
  },
  updateTags(state, tags) {
    state.video.tags = [...tags];
  },
  updateSelection(state, selection) {
    state.selection = { ...selection };
  },
  updateGrid(state, grid) {
    state.grid = { ...grid };
  },
  updateLastUsedColors(state, lastUsedColors) {
    state.lastUsedColors = [...lastUsedColors];
  }
};
